import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service-container">
      <h2>Terms of Service</h2>
      <p>
        By accessing this application, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this application. The materials contained in this application are protected by applicable copyright and trademark law.
      </p>
      <h5>1. Use License</h5>
      <p>
        Permission is granted to temporarily download one copy of the materials (information or software) on this application for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
      </p>
      <ul>
        <li>modify or copy the materials;</li>
        <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
        <li>attempt to decompile or reverse engineer any software contained on this application;</li>
        <li>remove any copyright or other proprietary notations from the materials; or</li>
        <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
      </ul>
      <p>
        This license shall automatically terminate if you violate any of these restrictions and may be terminated by us at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.
      </p>
      <h5>2. Disclaimer</h5>
      <p>
        The materials on this application are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
      </p>
      <p>
        Further, we do not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on this application or otherwise relating to such materials or on any sites linked to this application.
      </p>
      <h5>3. Limitations</h5>
      <p>
        In no event shall we or our suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on this application, even if we or an authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
      </p>
      <h5>4. Accuracy of materials</h5>
      <p>
        The materials appearing on this application could include technical, typographical, or photographic errors. We do not warrant that any of the materials on this application are accurate, complete or current. We may make changes to the materials contained on this application at any time without notice. However we do not make any commitment to update the materials.
      </p>
      <h5>5. Links</h5>
      <p>
        We have not reviewed all of the sites linked to this application and are not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by us of the site. Use of any such linked website is at the user's own risk.
      </p>
      <h5>6. Modifications</h5>
      <p>
        We may revise these terms of service for this application at any time without notice. By using this application you are agreeing to be bound by the then current version of these terms of service.
      </p>
      <h5>7. Governing Law</h5>
      <p>
        These terms and conditions are governed by and construed in accordance with the laws of our country and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
      </p>
    </div>
  );
};

export default TermsOfService;